import { IKImage } from "imagekitio-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { editPricingBanner } from "../../redux/actions/userActivity";
import { useNavigate } from "react-router-dom";
import { getLeads } from "../../redux/actions/userSubscription";

export default function PricingBanner({ deviceInfo }) {
  const dispatch = useDispatch();
  const pricing_banner = useSelector(
    (store) => store?.userActivity?.pricing_banner,
  );
  const user_id = useSelector((store) => store?.profileDetails?.id);
  const role_type = useSelector((store) => store?.userSubscription?.role_type);
  const navigate = useNavigate();
  if (!deviceInfo) {
    return null;
  }

  return (
    !pricing_banner && (
      <>
        <div
          className="fixed bottom-0 left-0 right-0 z-[999]  mx-auto flex w-[100%] items-center justify-around py-1 px-3 text-white shadow-lg lg:hidden"
          style={{
            "z-index": "999 !important",
            background:
              "linear-gradient(104.3deg, #040B23 20.51%, #040D2E 45.4%, #081338 57.55%, #030A23 86.32%)",
          }}
        >
          <div className="ml-2 mr-4">
            <FontAwesomeIcon
              icon={faTimes}
              size="lg"
              className="cursor-pointer"
              onClick={() => dispatch(editPricingBanner(true))}
            />
          </div>
          <div className="mr-1 whitespace-nowrap text-xs">
            For Best learning Exprience
          </div>
          {deviceInfo?.is_android === true && (
            <div className="flex h-10 cursor-pointer items-center justify-center">
              <div
                onClick={() =>
                  window.open(
                    "https://play.google.com/store/apps/details?id=com.learntube",
                    "_blank",
                    "noopener,noreferrer",
                  )
                }
              >
                <img
                  urlEndpoint="https://img.learntube.ai/public-assets/"
                  src={
                    "https://img.learntube.ai/public-assets/banner/googleplayButton.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1660911650301"
                  }
                  transformation={[
                    {
                      height: "110",
                      width: "110",
                    },
                  ]}
                  className="ml-1 h-auto w-24"
                />
              </div>
            </div>
          )}
          <div className="ml-3 flex cursor-pointer items-center justify-center">
            <button
              className="whitespace-nowrap rounded-lg px-1 py-2 text-[10px] font-semibold text-black"
              style={{
                background:
                  "linear-gradient(90deg, #FFF2B1 0%, #FDDC32 94.91%)",
              }}
              onClick={() => {
                dispatch(
                  getLeads({
                    user_id: user_id ? user_id : 0,
                    user_plan: role_type ? role_type : "basic",
                    product_id: 3,
                    product_name: "LearnTubeX",
                    product_type: "subscription",
                    is_visit: false,
                  }),
                );
                navigate("/pricing");
              }}
            >
              Upgrade Now
            </button>
          </div>
        </div>
        <div
          className="fixed bottom-0 left-0 right-0 z-[10000000000000] mx-auto hidden w-[100%] justify-center rounded p-1 px-2 font-bold text-white shadow-lg md:items-center  lg:flex"
          style={{
            "z-index": "1000000 !important",
            background:
              "linear-gradient(104.3deg, #040B23 20.51%, #040D2E 45.4%, #081338 57.55%, #030A23 86.32%)",
          }}
        >
          <div className="flex items-center justify-center text-base">
            Get
            <span className="text-[#FCE468]">
              &nbsp;Unlimited Certification
            </span>
            , Live Master Classes &{" "}
            <span className="text-[#FCE468]">
              &nbsp;Placement Support&nbsp;
            </span>
            with LearnTubeX
            <img
              urlEndpoint="https://img.learntube.ai/public-assets/"
              src={
                "https://img.learntube.ai/public-assets/banner/bannerImg.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1660911650046"
              }
              transformation={[
                {
                  height: "110",
                  width: "110",
                },
              ]}
              className="ml-10 h-12 w-16 scale-110"
            />
          </div>
          <div className="ml-3 flex cursor-pointer items-center justify-center">
            <button
              className="rounded-lg px-3 py-2 text-sm font-semibold text-black"
              style={{
                background:
                  "linear-gradient(90deg, #FFF2B1 0%, #FDDC32 94.91%)",
              }}
              onClick={() => {
                dispatch(
                  getLeads({
                    user_id: user_id ? user_id : 0,
                    user_plan: role_type ? role_type : "basic",
                    product_id: 3,
                    product_name: "LearnTubeX",
                    product_type: "subscription",
                    is_visit: false,
                  }),
                );
                navigate("/pricing");
              }}
            >
              Upgrade Now
            </button>
            {/* {deviceInfo?.is_android === true && <div onClick={() => {
                        window.open("https://play.google.com/store/apps/details?id=com.learntube", "_blank", 'noopener,noreferrer')
                    }}>
                        <img
                            urlEndpoint="https://img.learntube.ai/public-assets/"
                            src={"https://img.learntube.ai/public-assets/banner/googleplayButton.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1660911650301"}
                            transformation={[{
                                "height": "110",
                                "width": "110",
                            }]}
                            className="h-10 ml-4"
                        />
                    </div>} */}
          </div>
          <div className="absolute right-0 ml-5 mr-8">
            <FontAwesomeIcon
              icon={faTimes}
              size="lg"
              className="cursor-pointer"
              onClick={() => dispatch(editPricingBanner(true))}
            />
          </div>
        </div>
      </>
    )
  );
}
